// Translated from the English source with an external model, then reviewed. Regenerate with
// scripts/import-translation-bundle.ts rather than editing by hand — a hand edit here is lost
// the next time a bundle comes back.

const dictionary = {
  "nav": {
    "home": "Startseite",
    "map": "Karte",
    "tracker": "Sammlung",
    "resources": "Ressourcen",
    "fish": "Fische",
    "insects": "Insekten",
    "birds": "Vögel",
    "foraging": "Sammeln",
    "crops": "Feldfrüchte",
    "flowers": "Blumen",
    "animals": "Tiere",
    "recipes": "Rezepte",
    "locations": "Orte",
    "npcs": "NPCs",
    "shops": "Läden",
    "guides": "Ratgeber",
    "news": "Neuigkeiten",
    "achievements": "Erfolge",
    "weather": "Wetter",
    "events": "Events",
    "pets": "Haustiere",
    "dailyChecklist": "Tages-Checkliste",
    "codes": "Geschenkcodes",
    "winterTracker": "Winter-Tracker",
    "support": "Support",
    "about": "Über uns",
    "resourcesCollection": "Sammlung",
    "resourcesExplore": "Erkunden",
    "resourcesLearn": "Lernen",
    "menu": "Menü",
    "furniture": "Möbel",
    "wardrobe": "Garderobe",
    "buildings": "Bauen",
    "resourcesDecorate": "Dekorieren",
  },
  "search": {
    "placeholder": "Alles durchsuchen…",
    "categoryItems": "Sammlung",
    "categoryNpcs": "NPCs",
    "categoryLocations": "Orte",
    "categoryGuides": "Ratgeber",
    "categoryNews": "Neuigkeiten",
    "categoryAchievements": "Erfolge",
    "noResults": "Keine Ergebnisse gefunden",
    "noResultsHint": "Versuche einen anderen Suchbegriff",
    "navigate": "Navigieren",
    "select": "Auswählen",
    "close": "Schließen",
  },
  "language": {
    "title": "Sprache",
    "subtitle": "Wähle deine bevorzugte Sprache",
  },
  "footer": {
    "description": "Ein von Spielern erstellter Heartopia Feldguide für Routen, Rezepte, Orte und Sammelarbeit.",
    "quickLinks": "Schnellzugriff",
    "collection": "Sammlung",
    "copyright": "Heartopia Hub",
    "disclaimer": "Nicht verbunden mit den Entwicklern von Heartopia.",
  },
  "home": {
    "badge": "Inoffizielle Heartopia Begleitung",
    "titleStop": "Stopp",
    "titleWandering": "unterwegs.",
    "titleStart": "Beginne mit der Planung.",
    "description":
      "Heartopia.guide bringt Inselkarte, Rezepte, Kreaturen, NPCs und deinen Sammelfortschritt in einen ruhigen, schnellen Arbeitsbereich.",
    "openAtlas": "Atlas öffnen",
    "tracker": "Sammlung",
    "statCatalogued": "Katalogisierte Gegenstände",
    "statLayers": "Kartenebenen",
    "statFree": "Immer kostenlos",
    "islandAtlas": "Inselatlas",
    "mapLayerNpcs": "NPCs",
    "mapLayerShops": "Läden",
    "mapLayerAnimals": "Tiere",
    "mapHeading": "Heartopia Insel",
    "mapNearby": "in der Nähe",
    "openMap": "Karte öffnen",
    "meetLocals": "Triff die Einheimischen",
    "hintNpcs": "Gesprächsbereite NPCs auf einen Blick auf der Karte.",
    "hintShops": "Alle Läden mit ihren verfügbaren Artikeln zum Durchstöbern.",
    "hintAnimals": "Wildtiere an ihren üblichen Fundorten.",
    "explore": "Erkunden",
    "recipesPill": "Rezepte",
    "recipesTitle": "Cleverer kochen",
    "recipesDescription": "Durchstöbere Gerichte, Zutatenketten und den Sammelfortschritt, ohne zehn Tabs zu öffnen.",
    "viewRecipes": "Rezepte anzeigen",
    "ingr": "Zut.",
    "profit": "Gewinn",
    "animalsPill": "Wildtiere",
    "animalsTitle": "Alle kennenlernen",
    "animalsDescription": "Lieblingsfutter, Wetterfenster und Kartenhinweise für jedes Wildtier.",
    "viewAnimals": "Tiere anzeigen",
    "guidesPill": "Ratgeber",
    "guidesTitle": "Wähle einen Schwerpunkt",
    "guidesDescription": "Drei Wege hinein — springe direkt zu dem Guide, der zu deinem aktuellen Ziel passt.",
    "allGuides": "Alle Guides",
    "exploreGuide": "Guide öffnen",
  },
  "guides": {
    "pillLabel": "Feldguides",
    "titleLearn": "Lernen",
    "titleAccent": "Jedes System",
    "searchPlaceholder": "Guides durchsuchen…",
    "categoryAll": "Alle",
    "categoryBeginner": "Anfänger",
    "categoryCrafting": "Herstellen",
    "categoryCooking": "Cooking",
    "categoryFishing": "Fishing",
    "categoryExploration": "Erkundung",
    "difficultyEasy": "Einfach",
    "difficultyMedium": "Mittel",
    "difficultyHard": "Schwer",
    "allGuides": "Alle Guides",
    "by": "Von",
    "minRead": "Min. Lesezeit",
    "noResults": "Keine Guides gefunden. Versuche eine andere Suche oder Kategorie.",
    "relatedGuides": "Verwandte Guides",
    "readGuide": "Guide lesen",
  },
  "news": {
    "pillLabel": "Heartopia-News",
    "titleWhats": "Was ist",
    "titleAccent": "Neu",
    "searchPlaceholder": "News durchsuchen…",
    "categoryAll": "Alle",
    "categoryEvent": "Event",
    "categoryUpdate": "Update",
    "categoryGuide": "Guide",
    "categoryNews": "Neuigkeiten",
    "featured": "Empfohlen",
    "allNews": "Alle News",
    "read": "Lesen",
  },
  "map": {
    "controls": "Kartensteuerung",
    "zoomIn": "Hineinzoomen",
    "zoomOut": "Herauszoomen",
    "resetMap": "Karte zurücksetzen",
    "fullscreen": "Vollbild",
    "viewDetails": "Details anzeigen",
    "viewLocation": "Ort anzeigen",
    "openFullMap": "Vollständige Karte öffnen",
    "seeMore": "Mehr anzeigen",
    "close": "Schließen",
    "back": "Zurück",
    "guide": "Guide",
    "searchPlaceholder": "NPCs, Läden, Vögel, Fische suchen...",
    "clearSearch": "Suche löschen",
    "area": "Gebiet",
    "mapArea": "Kartengebiet",
    "event": "Event",
    "resource": "Ressource",
    "location": "Ort",
    "npc": "NPC",
    "shop": "Laden",
    "busStop": "Bushaltestelle",
    "wildAnimal": "Wildtier",
    "focus": "Fokus",
    "hide": "Ausblenden",
    "show": "Anzeigen",
    "showAllShops": "Alle Läden anzeigen",
    "showAllAnimals": "Alle Tiere anzeigen",
    "showBugAreas": "Insektengebiete anzeigen",
    "showBirdAreas": "Vogelgebiete anzeigen",
    "showResources": "Ressourcen auf der Karte anzeigen",
    "showEvents": "Events auf der Karte anzeigen",
    "showFishAreas": "Fischgebiete anzeigen",
    "viewAnimalAreas": "Tiergebiete anzeigen",
    "clickToView": "Zum Anzeigen klicken",
    "spots": "Fundorte",
    "meteorShower": "Meteorschauer",
    "foundIn": "Zu finden in",
    "more": "mehr",
    "sectionsNpcs": "NPCs",
    "sectionsShops": "Läden",
    "sectionsBusStops": "Bushaltestellen",
    "sectionsAnimals": "Tiere",
    "sectionsBugs": "Insekten",
    "sectionsBirds": "Vögel",
    "sectionsResources": "Ressourcen",
    "sectionsWeather": "Wetter",
    "sectionsEvents": "Events",
    "sectionsFish": "Fische",
    "shopClothes": "Kleidung",
    "shopFurniture": "Möbel",
    "shopPets": "Haustiere",
    "shopBookstore": "Buchladen",
    "helpTitle": "So benutzt du die Karte",
    "helpSearchLead": "Suche",
    "helpSearchText": "nach einem NPC, Laden, einer Kreatur oder einem Gebiet über die Leiste oben.",
    "helpLayersLead": "Ebenen",
    "helpLayersText":
      "in der Seitenleiste kannst du festlegen, war auf der Karte sichtbar ist: NPCs, Läden, Tiere, Ressourcen und mehr. Tippe auf eine Kategorie, um die vollständige Liste zu öffnen.",
    "helpClickLead": "Klicke auf eine Markierung, ein Gebiet oder einen Listeneintrag",
    "helpClickText":
      "um die wichtigsten Infos in der Karte unten auf der Karte zu sehen, mit einer Schaltfläche zur vollständigen Detailseite, sofern vorhanden.",
  },
  "locations": {
    "title": "Orte",
    "subtitleSuffix": "Orte über Heartopia Insel",
    "openMap": "Karte öffnen",
    "searchPlaceholder": "Suche Orte…",
    "allLocations": "Alle Orte",
    "npcsHere": "NPCs hier",
    "shopsHere": "Läden hier",
    "listings": "Einträge",
    "foundHereTitle": "Hier zu finden",
    "foundHereHint": "Kreaturen und Rohstoffe, die du an diesem Ort sammeln kannst.",
    "onTheMapTitle": "Auf der Karte",
    "sameRegionTitle": "Mehr in der Region {region}",
    "statNpcs": "NPCs",
    "statShops": "Läden",
    "statCollectibles": "Sammelobjekte",
    "levelShort": "Lv. {level}",
    "eventOnly": "Event",
    "seeListings": "Angebote ansehen",
    "seeAll": "Alle ansehen",
    "timeOfDay": "Tageszeit",
    "nothingHereTitle": "Hier ist noch nichts erfasst",
    "nothingHereBody":
      "Wir haben für diesen Ort keine Kreaturen, Läden oder NPCs erfasst. Wenn du hier etwas gefunden hast, ist die Karte der schnellste Weg, uns zu zeigen wo.",
    "regionTown": "Stadt",
    "regionNature": "Natur",
    "regionAdventure": "Abenteuer",
    "regionCoast": "Küste",
    "regionSea": "Meer",
    "regionRegion": "Region",
    "regionFishingVillage": "Fischerdorf",
    "regionForest": "Wald",
    "regionMountain": "Berg",
    "regionBeach": "Strand",
    "regionOther": "Sonstiges",
  },
  "catalog": {
    "howItWorks": "Wie es works",
    "fishPill": "Fishing-Enzyklopädie",
    "fishTitlePrefix": "Fangen",
    "fishTitleAccent": "Jeder Fische",
    "fishSearchPlaceholder": "Suche Fische, Lebensraum, Schatten size…",
    "fishSliderLabel": "Fishing-Stufe",
    "fishIntroTitle": "Angeln 101",
    "fishIntroP1":
      "Wirf deine Schnur in der Nähe eines Fischhabitats aus, um einen Fisch zu fangen — die Schattengröße zeigt dir an, wann er beißt.",
    "fishIntroP2":
      "Eine höhere Anglerstufe schaltet seltenere Fänge frei, und die Sternqualität erhöht den Verkaufspreis.",
    "fishUnknownHabitat": "Unbekannte Gewässer",
    "fishHabitat": "Lebensraum",
    "fishNoResultsTitle": "Keine Fische gefunden",
    "fishNoResultsBody": "Versuche deine Filter anzupassen.",
    "fishPastEventTitle": "Fische aus vergangenen Events",
    "fishHeaderTitle": "Fische",
    "fishColFish": "Fische",
    "fishColShadow": "Schatten",
    "insectsPill": "Bug Catching Enzyklopädie",
    "insectsTitlePrefix": "Fangen",
    "insectsTitleAccent": "Jeder Insekt",
    "insectsSearchPlaceholder": "Suche Insekten, Lebensraum…",
    "insectsSliderLabel": "Fangen Stufe",
    "insectsIntroTitle": "Bug Catching 101",
    "insectsIntroP1": "Verwenden dein Insekt net nahe ein Insekt's Lebensraum zu fangen es.",
    "insectsIntroP2":
      "Eine höhere Bug-Catching-Stufe schaltet seltenere Insekten frei, und die Sternqualität erhöht den Verkaufspreis.",
    "insectsUnknownHabitat": "Unbekannt",
    "insectsPastEventTitle": "Insekten aus vergangenen Events",
    "insectsHeaderTitle": "Insekten",
    "insectsColInsect": "Insekt",
    "birdsPill": "Birdwatching-Enzyklopädie",
    "birdsTitlePrefix": "Fundort",
    "birdsTitleAccent": "Jeder Vogel",
    "birdsSearchPlaceholder": "Suche Vögel, Lebensraum…",
    "birdsSliderLabel": "Birdwatching-Stufe",
    "birdsIntroTitle": "Birdwatching 101",
    "birdsIntroP1": "Wait nahe ein Vogel's Lebensraum mit dein camouflage bush zu snap ein photo.",
    "birdsIntroP2": "Eine höhere Birdwatching-Stufe schaltet seltenere Arten frei.",
    "birdsUnknownHabitat": "Unbekannt",
    "birdsPastEventTitle": "Vögel aus vergangenen Events",
    "birdsHeaderTitle": "Vögel",
    "birdsColBird": "Vogel",
    "cropsPill": "Farming Enzyklopädie",
    "cropsTitlePrefix": "Anbauen",
    "cropsTitleAccent": "Jeder Feldfrucht",
    "cropsSearchPlaceholder": "Suche Feldfrüchte…",
    "cropsIntroTitle": "Farming 101",
    "cropsIntroP1": "Pflanze Samen in dein farm Grundstück und Wasser sie täglich bis Ernte.",
    "cropsIntroP2":
      "Manche Feldfrüchte wachsen nur in bestimmten Jahreszeiten — prüfe das Jahreszeiten-Abzeichen, bevor du pflanzt.",
    "cropsAllSeasons": "Alle Jahreszeiten",
    "cropsGrowthTime": "Growth Zeit",
    "cropsGrowthTimeUnknown": "Unbekannt",
    "cropsGrowthTimeMinutesSuffix": "Min.",
    "cropsSortGrowthTime": "Growth Zeit",
    "cropsHeaderTitle": "Feldfrüchte",
    "cropsColCrop": "Feldfrucht",
    "cropsColSeason": "Saison",
    "flowersPill": "Gardening-Enzyklopädie",
    "flowersTitlePrefix": "Anbauen",
    "flowersTitleAccent": "Jeder Blume",
    "flowersSearchPlaceholder": "Suche Blumen…",
    "flowersIntroTitle": "Gardening 101",
    "flowersIntroP1": "Pflanze Blume Samen und Wasser sie zu bloom.",
    "flowersHeaderTitle": "Blumen",
    "flowersColFlower": "Blume",
    "forageablesPill": "Sammel-Enzyklopädie",
    "forageablesTitlePrefix": "Finde",
    "forageablesTitleAccent": "Jedes Sammelbares",
    "forageablesSearchPlaceholder": "Durchsuche Sammelbares…",
    "forageablesIntroTitle": "Sammeln 101",
    "forageablesIntroP1": "Gehe auf der Insel herum und sammle wilde Pflanzen und Pilze, wenn du sie findest.",
    "forageablesEnergy": "Energie",
    "forageablesSortEnergy": "Energie",
    "forageablesHeaderTitle": "Sammelbares",
    "forageablesColItem": "Gegenstand",
    "recipesPill": "Rezept Masterlist",
    "recipesTitlePrefix": "Kochen",
    "recipesTitleAccent": "Jeder Dish",
    "recipesSearchPlaceholder": "Suche Rezepte…",
    "recipesIntroTitle": "Cooking 101",
    "recipesIntroP1": "Sammeln Zutaten und verwenden ein stove, oven, oder grill zu kochen.",
    "recipesIntroP2": "Eine höhere Cooking-Stufe schaltet aufwendigere Rezepte mit besseren Gewinnspannen frei.",
    "recipesSortCookingLevel": "Cooking-Stufe",
    "recipesSortProfit": "Gewinn",
    "recipesEstProfit": "Geschätzter Gewinn",
    "recipesViewRecipe": "Anzeigen Rezept",
    "recipesHeaderTitle": "Rezepte",
    "recipesColDish": "Gericht",
    "recipesBeginnerFriendly": "Anfänger Friendly",
    "recipesBestStartersTitle": "Beste Rezepte zu Starten Mit",
    "recipesBestStartersSubtitle":
      "Niedrige Cooking-Stufe, solider Gewinn — gute Einsteigergerichte für dein erstes Cooking-Hobby.",
    "npcsPill": "Verzeichnis der Bewohner",
    "npcsTitlePrefix": "Lerne kennen:",
    "npcsTitleAccent": "Jeder NPC",
    "npcsSearchPlaceholder": "Suche NPCs…",
    "npcsFilterAll": "Alle",
    "npcsFilterMentors": "Mentoren",
    "npcsFilterShopkeepers": "Ladenbesitzer",
    "npcsFilterSpecial": "Besonders",
    "npcsNoResultsTitle": "Keine NPCs gefunden",
    "npcsNoResultsBody": "Versuche deine Suche anzupassen",
    "npcsResetFilters": "Zurücksetzen Filters",
    "locationsPill": "Inselatlas",
    "locationsTitlePrefix": "Erkunden",
    "locationsTitleAccent": "Jeder Ort",
    "locationsFilterAll": "Alle",
    "locationsNoResultsTitle": "Keine Orte gefunden",
    "locationsNoResultsBody": "Versuche deine Suche anzupassen",
    "locationsResetFilters": "Zurücksetzen Filters",
    "shopsPill": "Laden Directory",
    "shopsTitlePrefix": "Jeder",
    "shopsTitleAccent": "Laden In Stadt",
    "shopsRunBy": "Durchlauf von:",
    "shopsAt": "Bei",
    "shopsItemsForSale": "Gegenstände für sale",
    "shopsSearchPlaceholder": "Suche Läden, NPCs, Orte…",
    "shopsNoResultsTitle": "Keine Läden gefunden",
    "shopsNoResultsBody": "Versuche deine Suche anzupassen",
    "shopsResetFilters": "Zurücksetzen Filters",
    "animalsBadge": "Wildtier-Guide",
    "animalsTitlePrefix": "Lerne kennen:",
    "animalsTitleAccent": "Jeder Tier",
    "animalsPastEvent": "Vergangenes Event",
    "animalsPastEventTitle": "Tiere aus vergangenen Events",
    "trackerBadge": "Sammelfortschritt",
    "trackerTitle": "Heartopia-Tracker",
    "trackerDescription":
      "Markiere Fische, Insekten, Vögel, Feldfrüchte, Blumen, Sammelobjekte, Rezepte und Wildtiere als gesammelt. Der Fortschritt wird in diesem Browser gespeichert.",
    "trackerMetaDescription":
      "Verfolge deinen Heartopia Sammelfortschritt über Fische, Insekten, Vögel, Feldfrüchte, Blumen, Sammelbares, Tiere und Rezepte.",
    "trackerCategoryTitle": "{category}-Tracker",
    "trackerCategoryMetaDescription":
      "Verfolge deinen Heartopia {category} Sammelfortschritt — sieh, was du gefangen, angebaut oder gekocht hast, und was noch fehlt.",
    "trackerTotal": "Insgesamt",
    "trackerExport": "Exportieren",
    "trackerImport": "Importieren",
    "trackerReset": "Zurücksetzen",
    "trackerImportComplete": "Import abschließen.",
    "trackerImportFailed": "Import fehlgeschlagen.",
    "trackerSearchPlaceholder": "Suche Sammlung...",
    "trackerAllCategories": "Alle Kategorien",
    "trackerAllItems": "alle Gegenstände",
    "trackerCollected": "Gesammelt",
    "trackerMissing": "Fehlend",
    "trackerNoResults": "Keine Tracker-Gegenstände passen zu den aktuellen Filtern.",
    "furniturePill": "Möbel Catalogue",
    "furnitureTitlePrefix": "Jeder",
    "furnitureTitleAccent": "Piece von Möbel",
    "furnitureSearchPlaceholder": "Suche Möbel…",
    "furnitureMetaDescription":
      "Jedes Möbelstück in Heartopia — Beleuchtung, Stühle, Tische, Betten, Teppiche und Dekorationen — filterbar nach Typ, Raum und Farbe, mit allen Designvarianten und Ladenpreisen in Gold und Wishing Star.",
    "browseAll": "Alle",
    "browseVariants": "{count} Designs",
    "browseShowMore": "Anzeigen {count} mehr",
    "browseFacetRooms": "Raum",
    "browseFacetColors": "Farbe",
    "browseFacetSlots": "Platz",
    "browseFacetTypes": "Typ",
    "browseFacetSets": "Sammlungen",
    "browseCollectionsMore": "Sehen alle",
    "browseCollectionsLess": "Anzeigen fewer",
    "browseCollectionPieces": "{count} Teile",
    "browseFavourites": "Favoriten",
    "browseNoArt": "Für diesen Eintrag gibt es kein Bild.",
    "browseFacetStyles": "Bauen styles",
    "buildingsPill": "Bauen Mode Catalogue",
    "buildingsTitlePrefix": "Jeder",
    "buildingsTitleAccent": "Bauen Piece",
    "buildingsSearchPlaceholder": "Suche Türen, Dächer, Zeitfenster…",
    "buildingsMetaDescription":
      "Jeder build-mode piece in Heartopia — Türen, Zeitfenster, Dächer, Zäune, Wand sculptures und Wand oder Boden Texturen — gruppiert von bauen Stil, mit Preise und jeder design Variante.",
    "wardrobePill": "Garderobe Catalogue",
    "wardrobeTitlePrefix": "Jeder",
    "wardrobeTitleAccent": "Outfit & Accessoire",
    "wardrobeSearchPlaceholder": "Suche Kleidung…",
    "wardrobeMetaDescription":
      "Jeder Hut, jedes Oberteil, Unterteil, Paar Schuhe, jede Tasche und jedes Accessoire in Heartopia, filterbar nach Slot und Farbe, mit Ladenpreisen in Gold und Wishing Star.",
  },
  "genericDetail": {
    "subtitle": "Gegenstand Enzyklopädie Eintrag",
    "sellPrice": "Verkaufen Preis",
    "energy": "Energie",
    "whereToBuy": "Wo zum Kauf",
    "tags": "Tags",
    "crafted": "Hergestellt",
    "aliases": "Außerdem bekannt als",
    "howToObtain": "Wie zu obtain",
    "growsInto": "Grows In",
    "universalIngredientTitle": "Flexible Cooking-Zutat",
    "universalIngredientBody": "Kann beim Kochen in einem Rezept anstelle jeder beliebigen Zutat verwendet werden.",
  },
  "animalDetail": {
    "backLabel": "Alle Tiere",
    "subtitle": "Wildtier-Guide-Eintrag",
    "statLocation": "Ort",
    "statFavoriteWeather": "Lieblings Wetter",
    "foundInTitle": "Zu finden in",
    "favoriteFoodsTitle": "Lieblingsfutter",
    "noPinTitle": "Der genaue Fundort dieses Tiers ist noch nicht markiert.",
    "noPinDescription": "Es streift durch sein Gebiet, deshalb haben wir keinen festen Marker dafür eingetragen.",
    "weatherSunny": "Heiter",
    "weatherWet": "Regnerisch",
    "weatherRainbow": "Regenbogen",
    "weatherSnowy": "Verschneit",
    "faqTitle": "Häufig gestellte Fragen",
  },
  "cropDetail": {
    "backLabel": "Alle Feldfrüchte",
    "subtitle": "Farming Enzyklopädie Eintrag",
    "statGrowthTime": "Growth Zeit",
    "statSellPrice": "Verkaufen Preis",
    "aboutTitle": "Über uns",
    "seedCostTitle": "Samen Kosten",
    "usedInRecipesTitle": "Verwendet in Rezepte",
    "sellPriceByStarTitle": "Verkaufspreis nach Stern",
    "faqTitle": "Häufig gestellte Fragen",
    "shopsTitle": "Wo zu Buy Samen",
  },
  "creatureDetail": {
    "allBirds": "Alle Vögel",
    "allInsects": "Alle Insekten",
    "allFish": "Alle Fische",
    "birdSubtitle": "Birdwatching-Enzyklopädie-Eintrag",
    "insectSubtitle": "Bug Catching Enzyklopädie Eintrag",
    "fishSubtitle": "Fishing-Enzyklopädie-Eintrag",
    "statShadowSize": "Schatten Size",
    "markAsObtained": "Als erhalten markieren",
    "shopsTitle": "Wo zum Kauf",
    "locationsTitle": "Lebensraum",
    "sellPriceByStarTitle": "Verkaufspreis nach Stern",
    "faqTitle": "Häufig gestellte Fragen",
    "starChanceHint": "Chance auf diese Sternstufe",
    "statWeightRange": "Gewicht",
  },
  "forageableDetail": {
    "backLabel": "Alle Forageables",
    "subtitle": "Sammel-Enzyklopädie-Eintrag",
    "statEnergy": "Energie",
    "shopsTitle": "Wo zum Kauf",
    "locationsTitle": "Zu finden in",
    "aboutBody": "Gehe auf der Insel herum und sammle diese auf, wenn du sie in der Wildnis findest.",
    "faqTitle": "Häufig gestellte Fragen",
  },
  "flowerDetail": {
    "backLabel": "Alle Blumen",
    "shopsTitle": "Wo zu Buy Samen",
    "encyclopediaEntry": "Gardening-Enzyklopädie-Eintrag",
    "colorsTitle": "Farben",
    "otherColorsTitle": "Sonstiges Farben",
    "crossbreedingTitle": "Kreuzung",
    "crossbreedingFact1":
      "Funktioniert nur innerhalb derselben Art — eine Rose kann nur mit einer anderen Rose gekreuzt werden, niemals mit einer Tulpe.",
    "crossbreedingFact2":
      "Blumen haben eine Sternstufe (1–5). Zwei Eltern mit derselben Sternstufe können dieselbe Stufe oder die nächsthöhere hervorbringen; benachbarte Stufen wie 2★ und 3★ funktionieren genauso. Größere Abstände lassen sich nicht kreuzen, und 5★-Blumen sind das Maximum — es gibt keine weiteren Samen.",
    "crossbreedingFact3":
      "Die Farbe ist kein Zuchtbestandteil — die Farben der Eltern werden nicht zu einer dritten Farbe kombiniert. Jede Farbe gehört bei einer Art tendenziell zu einer bestimmten Sternstufe, daher hängt das Ergebnis stärker von der erreichten Sternstufe als von den Ausgangsfarben ab.",
    "crossbreedingFact4":
      "Bewässerung erhöht die Chancen, bis zu ungefähr 5 Personen insgesamt (du plus bis zu 4 Helfer). Deine Gardening-Stufe gibt außerdem einen eigenen Bonus. Die Ergebnisse werden nach dem Server-Reset um 6:00 Uhr bestimmt.",
    "crossbreedingDisclaimer":
      "Exact success percentages aren't publicly documented anywhere reliable noch — advancing ein tier ist möglich, never guaranteed.",
    "faqTitle": "Häufig gestellte Fragen",
  },
  "npcDetail": {
    "backLabel": "Alle NPCs",
    "aboutTitle": "Über uns",
    "funFactsTitle": "Wissenswertes",
    "foundInTitle": "Zu finden in",
    "itemsForSale": "Gegenstände für sale",
    "profileTitle": "Profil",
    "birthdayLabel": "Geburtstag",
    "zodiacLabel": "Sodiak",
    "mbtiLabel": "MBTI",
    "likesTitle": "Mag",
    "roleLabel": "Rolle",
    "teachesLabel": "Lehrt",
    "forSaleLabel": "Für Sale",
    "townsfolkFallback": "Stadtbewohner",
    "townsfolkSubtitle": "Townsfolk von Heartopia",
    "itemsSuffix": "Gegenstände",
    "noMapPinTitle": "Der genaue Standort dieses NPCs ist noch nicht markiert.",
    "noMapPinDescription":
      "Sie wandern umher oder wechseln den Ort, deshalb haben wir keinen festen Marker eingetragen.",
    "currencyGold": "Gold",
    "currencyStars": "Sterne",
    "currencyWishingStars": "Wishing Stars",
    "currencyMoonlightCrystals": "Moonlight Crystals",
    "currencyHeartDiamonds": "Heart Diamonds",
    "currencyExhibitionPasses": "Ausstellungspässe",
    "currencyContributionMedals": "Beitragsmedaillen",
    "seeAllShopItems": "Alle {count} Gegenstände in {shop} ansehen →",
  },
  "recipeDetail": {
    "backLabel": "Alle Rezepte",
    "subtitle": "Rezept Masterlist Eintrag",
    "statCookingLevel": "Cooking-Stufe",
    "statTool": "Werkzeug",
    "statSellPrice": "Verkaufen Preis",
    "shopsTitle": "Wo zum Kauf",
    "aboutTitle": "Über uns",
    "faqTitle": "Häufig gestellte Fragen",
    "ingredientsTitle": "Zutaten",
    "noIngredients": "Keine Zutaten für dieses Rezept erfasst.",
    "missingIngredientsTitle": "Wir kennen die Zutaten für dieses Rezept noch nicht",
    "missingIngredientsCta": "Tap zu hinzufügen sie",
    "suggestIngredientsModalTitle": "Vorschlagen Zutaten",
    "ingredientSearchPlaceholder": "Suche für ein Gegenstand…",
    "ingredientQtyLabel": "Menge",
    "addIngredientRow": "Hinzufügen Zutat",
    "removeIngredientRow": "Entfernen",
    "submitIngredients": "Senden Vorschlag",
    "submittingIngredients": "Wird gesendet …",
    "ingredientsSuccessMessage": "Danke! Wir überprüfen deinen Vorschlag bald.",
    "ingredientsErrorMessage": "Konnte gerade nicht gesendet werden — bitte versuche es später.",
    "itemNotFoundCta": "Kannst du es nicht finden? Schlag einen neuen Gegenstand vor",
    "newItemPendingBadge": "ausstehend",
    "suggestNewItemModalTitle": "Neuen Gegenstand vorschlagen",
    "newItemNameLabel": "Gegenstand Name",
    "newItemNamePlaceholder": "z. B. Mandarine",
    "newItemKindLabel": "Kategorie",
    "newItemNotesLabel": "Hinweise (optional)",
    "newItemNotesPlaceholder": "Alles, was beim Eintragen hilft — wo man es findet, wie es aussieht…",
    "submitNewItem": "Vorschlag senden",
    "submittingNewItem": "Wird gesendet …",
    "newItemSuccessMessage": "Danke! Wir überprüfen und fügen deinen Gegenstand bald hinzu.",
    "newItemErrorMessage": "Konnte gerade nicht gesendet werden — bitte versuche es später.",
    "anyTag": "beliebig",
    "possibleSubstitutesTitle": "Mögliche Ersatzstoffe",
    "possibleSubstitutesNote":
      "Jeder Kataloggegenstand dieses Typs — die tatsächlich akzeptierten Einträge in Heartopia können jedoch eingeschränkter sein.",
    "estIngredientCost": "Est. Zutat Kosten",
    "estProfit": "Geschätzter Gewinn",
    "sellPriceByStar": "Verkaufspreis nach Stern",
    "starScalingNote":
      "Standard-Skalierung beim Kochen (1x/1,5x/2x/4x/8x) — bei einer kleinen Zahl von Gerichten ist eine andere Tabelle bekannt.",
    "energyByStar": "Energie nach Stern",
    "toolStove": "Herd",
    "toolOven": "Ofen",
    "toolPopcornServingCart": "Popcornwagen",
    "toolPenguinStove": "Pinguin-Herd",
    "toolNone": "Keines",
    "faqIngredientsQuestion": "Wie kann ich {name} zubereiten?",
    "faqIngredientsAnswer": "Für {name} benötigst du: {ingredients}.",
    "faqLevelQuestion": "Welche Cooking-Stufe brauche ich für {name}?",
    "faqLevelAnswer": "Du brauchst Cooking-Stufe {level}, um {name} freizuschalten.",
    "faqSellQuestion": "Für wie viel wird {name} verkauft?",
    "faqSellAnswer": "{name} wird für {price} Gold verkauft.",
    "faqStarQuestion": "Wie viel ist ein 5-Sterne-{name} wert?",
    "faqStarAnswer":
      "{name} verkauft für {min} gold bei 1★ und {max} gold bei 5★ — {times}× mehr für ein perfect kochen.",
    "faqEnergyQuestion": "Wie viel Energie stellt {name} wieder her?",
    "faqEnergyAnswer": "{name} restores {min} Energie bei 1★ und {max} Energie bei 5★.",
    "toolBrickServingCart": "Ziegel-Servierwagen",
  },
  "common": {
    "loading": "Wird geladen",
    "overviewTitle": "Übersicht",
    "viewDetails": "Details anzeigen",
    "cards": "Karten",
    "list": "Auflisten",
    "sort": "Sortieren",
    "name": "Name",
    "level": "Stufe",
    "price": "Verkaufen Preis",
    "clearFilters": "Klar filters",
    "day": "Tag",
    "days": "Tage",
    "shadowSizeSmall": "Klein",
    "shadowSizeMedium": "Mittel",
    "shadowSizeLarge": "Groß",
    "shadowSizeGolden": "Gold",
    "usedInRecipesTitle": "Verwendet in Rezepte",
    "aboutTitle": "Über uns",
  },
  "itemFaq": {
    "whereToFindQuestion": "Wo finde ich {name} in Heartopia?",
    "whereToFindByLocationsAnswer": "{name} findest du bei {locations}.",
    "whereToFindByHabitatAnswer": "{name} kommt im Lebensraum {habitat} vor.",
    "levelRequiredQuestion": "Welche Stufe brauche ich, um {name} zu fangen?",
    "levelRequiredAnswer": "Du brauchst mindestens Stufe {level}, um {name} zu fangen.",
    "sellPriceQuestion": "Für wie viel wird {name} verkauft?",
    "sellPriceAnswer": "{name} wird für {price} Gold verkauft.",
    "sellPriceWithShadowAnswer":
      "{name} wird für {price} Gold verkauft und hat beim Fishing die Schattengröße {shadowSize}.",
    "weatherQuestion": "Bei welchem Wetter erscheint {name}?",
    "weatherAnswer": "{name} erscheint bei: {weather}.",
    "usedForQuestion": "Wofür wird {name} verwendet?",
    "usedForAnswer": "{name} stellt beim Verzehr {energy} Energie wieder her.",
  },
  "recipeFaq": {
    "ingredientsQuestion": "Welche Zutaten brauche ich für {name}?",
    "ingredientsAnswer": "Für {name} brauchst du: {ingredients}.",
    "cookingLevelQuestion": "Welche Kochstufe brauche ich für {name}?",
    "cookingLevelAnswer": "Du brauchst Kochstufe {level}, um {name} freizuschalten.",
    "sellPriceQuestion": "Für wie viel wird {name} verkauft?",
    "sellPriceAnswer": "{name} wird für {price} Gold verkauft.",
  },
  "itemDescription": {
    "foundAtClause": "ist bei {locations} zu finden",
    "foundInHabitatClause": "ist im Lebensraum {habitat} zu finden",
    "requiresLevelClause": "erfordert mindestens Stufe {level} zum Erhalten",
    "sellsForClause": "wird für {price} Gold verkauft",
    "restoresEnergyClause": "stellt beim Verzehr {energy} Energie wieder her",
    "joinWord": "und",
  },
  "starTooltip": {
    "profitTitle": "Sterne-Multiplikatoren",
    "profitSubtitle": "Gewinn pro Sternwertung",
    "profitFooterLabel": "Gewinn bei 1★",
    "sellPriceTitle": "Sterne-Multiplikatoren",
    "sellPriceSubtitle": "Verkaufspreis pro Sternwertung",
    "sellPriceFooterLabel": "1★ Verkaufen Preis",
  },
  "mastery": {
    "trackFishing": "Fishing-Meisterschaft",
    "trackBugCatching": "Bug-Catching-Meisterschaft",
    "trackBirdwatching": "Birdwatching-Meisterschaft",
    "trackFarming": "Farming-Meisterschaft",
    "trackCooking": "Cooking-Meisterschaft",
    "unitCatches": "Fänge",
    "unitCaptures": "Fangaktionen",
    "unitHarvests": "Ernten",
    "unitPreparations": "Zubereitungen",
    "rankNovice": "Anfänger",
    "rankExpert": "Experte",
    "rankMaster": "Meister",
    "trophyUnlocked": "Trophäe freigeschaltet",
    "footerHint": "Tap ein rank zu mark dein Fortschritt. Erreichen Meister zu freischalten der trophy.",
    "unknownBody": "Wir kennen die Mastery-Schwellen für diesen Gegenstand noch nicht.",
    "unknownCta": "Kennst du sie? Sag uns Bescheid",
    "suggestFieldLabel": "Novice-Schwelle",
    "suggestHint":
      "Nur die Novice-Zahl — Expert ist das 3-Fache, Master das 6-Fache, bei jedem Gegenstand, den wir bestätigt haben.",
  },
  "statSuggestion": {
    "unknownLabel": "Wissen wir noch nicht",
    "suggestValueCta": "Vorschlagen ein value",
    "explainer":
      "Diese Angabe ist noch nicht bestätigt. Wenn du sie aus dem Spiel kennst, teile sie unten mit — jeder Vorschlag wird vor der Veröffentlichung auf der Website geprüft, also kein Druck, 100 % sicher zu sein.",
    "genericHint": "Nur der Nummer, no need für extra formatting.",
    "energyHint": "Der amount von Energie restored wenn diese Gegenstand ist consumed.",
    "sellPriceHint":
      "Der Verkaufspreis eines Gegenstands bei 1★ in Gold — daraus berechnen wir die übrigen Sternstufen.",
    "habitatHint": "Wo es ist gefunden — der Ort oder Gebiet Name.",
    "growthTimeHint": "In Minuten (e.g. 90 für 1h30m, 1440 für 1 Tag).",
    "valueLabel": "Wert",
    "customOption": "Sonstiges (Typ dein own)",
    "habitatTranslationFieldLabel": "Name des Lebensraums in dieser Sprache",
    "habitatTranslationHint": "Wie dieser Ort bzw. dieses Gebiet in dieser Sprache heißt.",
    "submitButton": "Vorschlag senden",
    "submitting": "Wird gesendet …",
    "successMessage": "Danke! Wir überprüfen deinen Vorschlag bald.",
    "errorMessage": "Konnte gerade nicht gesendet werden — bitte versuche es später.",
  },
  "imageSuggestion": {
    "triggerLabel": "Vorschlagen ein Bild",
    "triggerLabelReplace": "Vorschlagen ein anders Bild",
    "fieldLabel": "Vorschlagen ein Bild",
    "explainer":
      "Wir haben dafür noch kein bestätigtes Bild. Lade eines hoch, das du hast — jeder Vorschlag wird vor der Veröffentlichung auf der Website geprüft.",
    "explainerReplace":
      "Ist dieses Bild falsch oder hast du ein besseres? Lade es hoch — jeder Vorschlag wird geprüft, bevor es das aktuelle Bild ersetzt.",
    "pickFile": "Wähle ein Foto (JPEG, PNG oder WebP)",
    "hint": "Max. 5 MB. Bitte stelle sicher, dass das Bild tatsächlich diesen Gegenstand zeigt.",
    "invalidType": "Nur JPEG-, PNG- oder WebP-Bilder werden akzeptiert.",
    "tooLarge": "Das Bild muss 5 MB oder kleiner sein.",
    "submitButton": "Bild senden",
    "submitting": "Wird hochgeladen …",
    "successMessage": "Danke! Wir überprüfen dein Bild bald.",
    "errorMessage": "Konnte gerade nicht hochgeladen werden — bitte versuche es später.",
  },
  "generalFeedback": {
    "triggerLabel": "Etwas falsch? Korrektur vorschlagen",
    "fieldLabel": "Was stimmt nicht?",
    "hint": "Falsche Beschreibung, falsches Bild, was auch immer — sag uns, was wir korrigieren sollen.",
  },
  "pageFeedback": {
    "triggerLabel": "Melde ein Problem mit dieser Seite",
    "fieldLabel": "Was ist falsch?",
    "hint": "Tippfehler, kaputte Anleitung, veraltete Info — sag uns Bescheid.",
    "explainer":
      "Wir haben das noch nicht bestätigt. Wenn dir etwas auffällt, teile es unten — jede Einsendung wird geprüft, bevor wir etwas ändern. Du musst dir also nicht 100 % sicher sein.",
    "submitButton": "Feedback senden",
    "submitting": "Wird gesendet …",
    "successMessage": "Danke! Wir schauen uns das bald an.",
    "errorMessage": "Konnte gerade nicht gesendet werden — bitte versuche es später.",
  },
  "mapAreaUnknown": {
    "title": "Wir kennen dieses Gebiet noch nicht.",
    "description": "Hilf der Community, indem du Ortsdaten für diesen Gegenstand beisteuerst.",
    "cta": "Hilf uns, das zu ergänzen",
    "fieldLabel": "Ort / Gebiet",
    "hint": "Beschreibe, wo du es gefunden hast — den Namen des Orts und markante Punkte in der Nähe.",
    "notPinnedTitle": "Dieser Ort ist noch nicht auf der Karte markiert.",
    "notPinnedDescription": "Wir kennen die ungefähre Gegend, haben aber keinen genauen Marker eingetragen.",
  },
  "itemGuides": {
    "title": "Verwandte Guides",
  },
  "itemFallback": {
    "badge": "Übersetzung ausstehend",
    "message": "Wir kennen den Namen dieses Gegenstands in dieser Sprache noch nicht.",
    "usingEnglish": "Englisch wird verwendet:",
    "helpMessage": "Wir kennen den Namen dieses Gegenstands noch nicht. Willst du uns helfen?",
    "helpCta": "Hilf uns beim Übersetzen",
    "modalTitle": "Übersetzung vorschlagen",
    "fieldPlaceholder": "Name des Gegenstands in dieser Sprache",
    "submitButton": "Vorschlag senden",
    "submitting": "Wird gesendet …",
    "successMessage": "Danke! Wir überprüfen deinen Vorschlag bald.",
    "errorMessage": "Konnte gerade nicht gesendet werden — bitte versuche es später.",
  },
  "notFoundPage": {
    "title": "404",
    "subtitle": "Oops, diese Seite konnte nicht gefunden werden.",
    "description":
      "Du hast dich in ein Gebiet verirrt, das es in Heartopia noch nicht gibt. Finde zurück zum richtigen Pfad.",
    "primaryCta": "Zur Startseite zurück",
    "secondaryCta": "Weltkarte anzeigen",
  },
  "achievements": {
    "pill": "Erfolge",
    "titlePrefix": "Entsperre jeden",
    "titleAccent": "Erfolge",
    "subtitle": "Verfolgen dein Fortschritt und entdecken wie zu freischalten jeder achievement in Heartopia.",
    "searchPlaceholder": "Suche Erfolge…",
    "filterAll": "Alle",
    "showHidden": "Anzeigen Verborgen",
    "hideHidden": "Ausblenden Verborgen",
    "statTotal": "Insgesamt",
    "statCompleted": "Abgeschlossen",
    "statHidden": "Verborgen",
    "noResultsTitle": "Keine Erfolge gefunden",
    "noResultsBody": "Versuche eine andere Suche oder einen anderen Filter.",
    "resetFilters": "Zurücksetzen filters",
    "lockedTitle": "???",
    "lockedBody": "Diese achievement ist noch ein mystery.",
    "titleGainedLabel": "Titel Erhalten",
    "hintLabel": "Hinweis",
    "notesLabel": "Hinweise",
    "markDone": "Als erledigt markieren",
    "markNotDone": "Als nicht erledigt markieren",
    "backToList": "Zurück zu Erfolge",
    "relatedTitle": "Verwandt Erfolge",
    "faqTitle": "Häufig gestellte Fragen",
  },
  "share": {
    "title": "Teilen",
    "shareVia": "Teilen via…",
    "copyLink": "Link kopieren",
    "linkCopied": "Kopiert!",
  },
  "weather": {
    "pill": "Wetter Station",
    "titlePrefix": "Heartopia",
    "titleAccent": "Vorhersage",
    "subtitle":
      "Prüfe die Bedingungen, plane deine Route und Fundorte für Events und bereite dich auf seltene Spawns vor.",
    "directoryTitle": "Wetter- & Event-Guides",
    "specialEvent": "Besonderes Event",
    "openGuide": "Guide öffnen",
    "backToWeather": "Zurück zu Wetter",
    "overviewTitle": "Übersicht",
    "checklistTitle": "Wenn Du Nur Haben 10 Minuten",
    "activitiesTitle": "Wichtige Aktivitäten",
    "bestForTitle": "Beste Für",
    "creaturesTitle": "Verfügbar Während Diese Wetter",
    "creaturesMore": "mehr",
    "creaturesShowLess": "Anzeigen fewer",
    "noCreaturesData": "Für dieses Wetter haben wir noch keine Kreaturen erfasst.",
    "faqTitle": "Häufig gestellte Fragen",
  },
  "events": {
    "pill": "Heartopia Zeitplan",
    "titlePrefix": "Aktiv",
    "titleAccent": "Events",
    "subtitle": "Von major saisonal festivals zu schnell täglich minigames, finden alles happening in Heartopia.",
    "minigamesTitle": "Wiederkehrende Minispiele",
    "seasonalTitle": "Saisonale & Kollaborations-Events",
    "activeLabel": "Aktiv",
    "endedLabel": "Beendet",
    "viewEvent": "Event ansehen",
    "backToEvents": "Zurück zu den Events",
    "requirementsTitle": "Voraussetzungen",
    "locationTitle": "Ort",
    "costTitle": "Eintrag Kosten",
    "freeLabel": "Kostenlos",
    "dgLevelLabel": "Developer's Gilde Stufe",
    "questLabel": "Quest",
    "hobbyLabel": "Hobby",
    "quickFactsTitle": "Schnell Facts",
    "unlockLabel": "Freischalten",
    "npcAreaLabel": "NPC / Gebiet",
    "durationLabel": "Dauer",
    "typeLabel": "Typ",
    "howToStartTitle": "Wie zu Starten",
    "howItWorksTitle": "Wie Es Works",
    "goalsRewardsTitle": "Goals & Belohnungen",
    "tipsTitle": "Tips / Strategie",
    "datesTitle": "Event-Termine",
    "overviewTitle": "Übersicht",
    "highlightsTitle": "Highlights",
    "standoutRewardTitle": "Standout Belohnung",
    "faqTitle": "Häufig gestellte Fragen",
  },
  "pets": {
    "hubBadge": "Haustier-Guide",
    "hubTitlePrefix": "Heartopia",
    "hubTitleAccent": "Haustiere",
    "hubSubtitle": "Alles du need zu freischalten, adoptieren, und Pflege für Haustiere.",
    "hubUnlockTitle": "Freischalten Haustier Caring",
    "hubUnlockDesc": "Normalerweise bei Developer/Mitglied Stufe 12 via Resident Anfragen.",
    "hubOrderTitle": "Katze Erste",
    "hubOrderDesc": "Du must adoptieren ein Katze vor Hunde freischalten.",
    "hubRotationTitle": "Täglich Rotation",
    "hubRotationDesc": "3 Katzen + 3 Hunde wechseln jeder Tag bei der Adoption Zentrum.",
    "cardDogsTitle": "Hunde",
    "cardDogsSubtitle": "Rassen • Caring • Gruppen",
    "cardDogsDesc": "37 Rassen mit size Gruppen und caring Hinweise.",
    "cardCatsTitle": "Katzen",
    "cardCatsSubtitle": "Rassen • Eigenschaften • Coats",
    "cardCatsDesc": "18 Rassen mit coat Varianten und Farben.",
    "cardTraitsTitle": "Eigenschaften",
    "cardTraitsSubtitle": "Alle Eigenschaften + Suche",
    "cardTraitsDesc": "Searchable auflisten von Eigenschaften und ihr effects.",
    "cardGuideTitle": "Guide",
    "cardGuideSubtitle": "Freischalten • Adoptieren • Pflege",
    "cardGuideDesc": "Freischalten flow plus der täglich Adoption/Pflege Runde.",
    "dogsBadge": "Hunde-Guide",
    "dogsTitlePrefix": "Heartopia",
    "dogsTitleAccent": "Hunde",
    "dogsSubtitle": "Freischalten, adoptieren, und Pflege für Hunde mit ein clean Rasse Katalog.",
    "catsBadge": "Katze Guide",
    "catsTitlePrefix": "Heartopia",
    "catsTitleAccent": "Katzen",
    "catsSubtitle": "Rassen, Eigenschaften, und Pflege — clean und separated.",
    "quickInfoRotationTitle": "Täglich Rotation",
    "quickInfoRotationDesc": "3 Katzen + 3 Hunde wechseln jeder Tag.",
    "quickInfoUnlockTitle": "Freischalten",
    "quickInfoUnlockDesc": "Hund Caring opens nach Katze Caring.",
    "quickInfoOrderTitle": "Katze Erste",
    "quickInfoOrderDesc": "Katzen freischalten vor Hunde.",
    "quickInfoTraitsTitle": "Random Eigenschaften",
    "quickInfoTraitsDescDogs": "Eigenschaften sind random, nicht tied zu Rasse.",
    "quickInfoTraitsDescCats": "Eigenschaften sind random und behavior-focused.",
    "searchPlaceholder": "Suche Rassen…",
    "filterAll": "Alle",
    "filterSmall": "Klein",
    "filterMedium": "Mittel",
    "filterLarge": "Groß",
    "noResults": "Keine Rassen gefunden",
    "traitsBadge": "Haustier Eigenschaften",
    "traitsTitlePrefix": "Alle",
    "traitsTitleAccent": "Eigenschaften",
    "traitsSubtitle": "Jeder trait ein Haustier kann haben und was es means für täglich Pflege.",
    "traitsSearchPlaceholder": "Suche Eigenschaften…",
    "effectLabel": "Effekt",
    "guideBadge": "Haustier Caring",
    "guideTitlePrefix": "Adoption",
    "guideTitleAccent": "Guide",
    "guideSubtitle": "Freischalten Haustier caring, adoptieren dein erste Katze, dann expand zu Hunde.",
    "guideStepsTitle": "Wie zu Freischalten",
    "guideAdoptionTitle": "Wie Adoption Works",
    "guideCareTitle": "Täglich Pflege Runde",
    "backToPets": "Zurück zu Haustiere",
    "viewBreed": "Anzeigen Rasse",
    "groupLabel": "Größe",
    "dogLabel": "Hund",
    "catLabel": "Katze",
    "variantsLabel": "Bekannt Coat Varianten",
    "suggestTitle": "Fehlend ein Rasse oder detail?",
    "suggestDogsBody":
      "Hilf uns, den Hundekatalog zu erweitern — mit einer Rasse, einer Variante oder einer Korrektur.",
    "suggestCatsBody":
      "Hilf uns, den Katzenkatalog zu erweitern — mit einer Rasse, einer Fellvariante oder einer Korrektur.",
    "suggestButton": "Vorschlagen ein Eintrag",
    "suggestFieldLabel": "Haustier Informationen",
    "suggestHint": "Teilen der Rasse, Variante, Quelle, oder Berichtigung du wissen.",
    "viewAllTraits": "Anzeigen alle Eigenschaften",
  },
  "dailyChecklist": {
    "badge": "Täglich Tracker",
    "titlePrefix": "Täglich",
    "titleAccent": "Heartopia",
    "subtitle": "Verfolgen dein täglich Aufgaben, Ressourcen, und Laden rotations. Alles setzt zurück mit ein Neu Tag.",
    "progressTitle": "Täglich Fortschritt",
    "progressComplete": "abschließen",
    "allDone": "Congratulations! du hast completed alle von heute's Aufgaben!",
    "quickTasksTitle": "Schnell Aufgaben",
    "quickTasksDesc": "Essential täglich actions dass zurücksetzen jeweils Tag.",
    "shopsTitle": "Laden Rotations",
    "shopsDesc": "Prüfen rotierend Vorrat von diese vendors.",
    "resetInfo": "Setzt zurück automatically based auf dein local date.",
    "customTitle": "Custom Aufgaben",
    "addCustom": "Hinzufügen",
    "customPlaceholder": "Aufgabe Name…",
    "customEmpty": "No custom Aufgaben noch.",
    "remove": "Entfernen",
  },
  "codes": {
    "badge": "Redemption Zentrum",
    "title": "Geschenk",
    "titleAccent": "Codes",
    "subtitle": "Löse diese Codes im Spiel ein, um besondere Belohnungen, Gold und exklusive Gegenstände zu erhalten!",
    "statActive": "Aktiv",
    "statExpired": "Abgelaufen",
    "statTotal": "Insgesamt",
    "howToTitle": "Wie zu Einlösen",
    "howToStep1": "Öffnen der game Menü",
    "howToStep2": "Tippe auf „Einstellungen“ > „Code einlösen“",
    "howToStep3": "Gib den Code genau so ein, wie er angezeigt wird.",
    "howToStep4": "Bestätigen und receive dein Belohnungen!",
    "rewardsLabel": "Belohnungen",
    "noRewardsLabel": "Keine Belohnungen aufgelistet",
    "starQualityHint": "Dieser Code gewährt den Gegenstand mit einer bestimmten Sternqualität.",
    "unconfirmedRewardHint":
      "Diesen Gegenstand haben wir noch nicht im Katalog, deshalb steht hier die rohe Spiel-ID statt eines bestätigten Namens.",
    "expiredText": "Dieser Code ist abgelaufen und kann nicht mehr eingelöst werden.",
    "copyCode": "Code kopieren",
    "copied": "Kopiert!",
    "statusActive": "Aktiv",
    "statusExpired": "ABGELAUFEN",
    "redeemedLabel": "Eingelöst",
    "markRedeemed": "Als eingelöst markieren",
    "unmarkRedeemed": "Als nicht eingelöst markieren",
    "goldLabel": "Gold",
    "starLabel": "Wishing Star",
    "heartLabel": "Moonlight Crystal",
    "maintenanceNote":
      "Codes werden regelmäßig geprüft, können aber ohne Ankündigung ablaufen — wenn einer im Spiel nicht funktioniert, ist er wahrscheinlich veraltet.",
  },
  "winterTracker": {
    "badge": "Fashionwave-Journal",
    "titlePrefix": "Winter Frost",
    "titleAccent": "Gegenstände Tracker",
    "subtitle":
      "Verfolge jeden zeitlich begrenzten Gegenstand aus der Winter-Frost-Saison — das Event ist beendet, aber du kannst weiterhin nachsehen, was verfügbar war.",
    "endedNote":
      "Dieses Event ist beendet — die hier gezeigten Gegenstände sind im Spiel nicht mehr erhältlich. Sie dienen als Referenz für das frühere Angebot.",
    "searchPlaceholder": "Suche Gegenstände…",
    "filterAll": "Alle",
    "filterAccessory": "Accessoires",
    "filterBag": "Taschen",
    "filterClothing": "Kleidung",
    "filterFurniture": "Möbel",
    "filterEmote": "Emotes",
    "filterVehicle": "Fahrzeuge",
    "filterTool": "Werkzeuge",
    "filterPet": "Haustier Gegenstände",
    "filterPuzzle": "Rätsel",
    "collected": "Gesammelt",
    "missing": "Fehlend",
    "noResults": "Keine Gegenstände gefunden",
    "costLabel": "Fashionwave Token",
    "backToEvent": "Zurück zu Winter Frost",
  },
  "support": {
    "badge": "Unterstütze heartopia.guide",
    "titlePrefix": "Halte das",
    "titleAccent": "Herz",
    "titleSuffix": "am Schlagen",
    "subtitle":
      "heartopia.guide ist ein Herzensprojekt für die Community. Dein Support hilft dabei, die Server am Laufen zu halten und Updates zu veröffentlichen!",
    "donateCta": "Projekt unterstützen",
    "donateDescription": "Jeder Beitrag hilft, Hosting, Domain und Entwicklungszeit zu decken.",
    "creatorLabel": "Lucas Diniz",
    "creatorRole": "Ersteller von heartopia.guide",
    "creatorBadge": "Entwickler & Designer",
    "footerNote": "Danke, dass du Teil dieser Reise bist!",
  },
  "about": {
    "badge": "Fan Project · Inoffiziell",
    "title": "Über Heartopia Guide",
    "subtitle":
      "Heartopia Guide ist eine von der Community erstellte Website, die Spielern hilft, nützliche Spielinformationen zu finden — Guides, Tracker, Checklisten, Gegenstände und Event-Referenzen — schnell und übersichtlich.",
    "lastUpdatedLabel": "Andauern aktualisiert",
    "pillEventTrackers": "Event-Tracker",
    "pillGuides": "Guides",
    "pillChecklists": "Checklisten",
    "pillAlwaysUpdated": "Immer Aktualisiert",
    "whatYouFindTitle": "Was wirst du finden here",
    "whatYouFind1": "Event-Tracker und Gegenstandslisten (wenn verfügbar)",
    "whatYouFind2": "Guides und reference Seiten für game mechanics",
    "whatYouFind3": "Praktische Seiten, die tägliche und wöchentliche Routinen einfacher machen",
    "whatYouFind4": "Ein Website dass evolves über Zeit — aktualisiert als Neu Informationen becomes verfügbar",
    "transparencyTitle": "Transparency und fan project notice",
    "transparencyP1":
      "Dies ist ein unabhängiges, inoffizielles Fan-Projekt. Wir sind weder mit den Entwicklern oder Publishern von Heartopia verbunden noch werden wir von ihnen gesponsert oder unterstützt.",
    "transparencyP2": "Alle trademarks, Namen, und assets belong zu ihr respective owners.",
    "creatorTitle": "Who's behind diese",
    "creatorIntro": "heartopia.guide ist kein anonymes Projekt — es wird von einer echten Person gebaut und gepflegt.",
    "creatorName": "Lucas Diniz",
    "creatorRole": "Creator & Developer von heartopia.guide",
    "creatorLinkLabel": "lucashdo.com",
    "sourcesTitle": "Wo Informationen comes von",
    "sourcesIntro": "Informationen kann sein sourced von:",
    "sourcesItem1": "im Spiel observation und testing",
    "sourcesItem2": "Beiträge der Community",
    "sourcesItem3": "Offizielle Spiel-Updates",
    "sourcesNote":
      "Trotz sorgfältiger Pflege können einige Daten unvollständig oder veraltet sein — besonders während laufender Events.",
    "adsTitle": "Werbung und sustainability",
    "adsP1":
      "Um die Seite am Laufen zu halten und die Kosten zu decken (Domain, Hosting, Tools), zeigen wir möglicherweise Werbung an.",
    "adsP2":
      "Werbung Dienste such als Google kann verwenden Cookies oder similar technologies zu serve und measure Werbung.",
    "copyrightTitle": "Urheberrecht",
    "copyrightText":
      "Wenn du Rechteinhaber bist und der Meinung bist, dass Inhalte entfernt oder angepasst werden sollten, kontaktiere uns mit den betreffenden URLs und Details. Wir prüfen das und handeln so schnell wie möglich.",
    "contactTitle": "Kontakt",
    "contactEmailLabel": "E-Mail",
    "footerNote": "Made mit love von der Heartopia Community",
  },
  "legal": {
    "lastUpdatedLabel": "Andauern aktualisiert",
    "lastUpdatedValue": "2026-02-13",
    "contactHeading": "Kontakt",
    "contactLinkLabel": "Über uns & Kontakt Seite",
    "privacyTitle": "Datenschutzerklärung",
    "privacyIntro":
      "Diese Datenschutzerklärung erklärt, wie heartopia.guide personenbezogene Daten erhebt, verwendet und schützt, wenn du auf diese Website zugreifst.",
    "privacyDataHeading": "Daten, die wir erheben können",
    "privacyData":
      "Je nachdem, wie du die Website nutzt, können wir Folgendes erheben: Nutzungsdaten (aufgerufene Seiten, Klicks, Datum/Uhrzeit, Referrer, Geräte-/Browsertyp, Sprache); technische Kennungen (z. B. IP-Adressen in Protokollen sowie Sicherheits- und Leistungsdaten); Cookies und ähnliche Technologien (siehe Cookie-Richtlinie); sowie Daten, die du bereitstellst (z. B. wenn du uns eine E-Mail schreibst oder Feedback einreichst). Wir fragen nicht nach sensiblen Daten (z. B. Gesundheit, Religion oder biometrischen Daten).",
    "privacyHowWeUseHeading": "Wie wir Daten verwenden",
    "privacyHowWeUse":
      "Wir verwenden Daten, um die Website bereitzustellen und zu warten, Inhalte und Leistung zu verbessern, Missbrauch und Betrug zu verhindern, auf Nachrichten und Support-Anfragen zu reagieren, die Reichweite zu messen, sofern aktiviert, sowie Werbung bereitzustellen und deren Leistung zu messen, sofern dies zutrifft.",
    "privacySharingHeading": "Weitergabe",
    "privacySharing":
      "Wir geben Daten möglicherweise an Dienstleister weiter (Hosting, Analyse, CDN und/oder Werbung), um die Seite zu betreiben; wenn es gesetzlich vorgeschrieben ist (Gerichtsbeschlüsse, behördliche Pflichten); und um die Seite und ihre Nutzer zu schützen. Wir verkaufen keine personenbezogenen Daten.",
    "privacyRetentionHeading": "Aufbewahrung",
    "privacyRetention":
      "Wir speichern Daten nur so lange, wie es für die beschriebenen Zwecke nötig ist (oder gesetzlich vorgeschrieben). Technische Logs können für begrenzte Zeit zu Sicherheits- und Diagnosezwecken aufbewahrt werden.",
    "privacyRightsHeading": "Dein Rechte",
    "privacyRights":
      "Du kannst die dir nach geltendem Recht zustehenden Rechte geltend machen (z. B. Auskunft, Berichtigung, Löschung, Datenübertragbarkeit soweit anwendbar, Information über die Weitergabe, Widerruf der Einwilligung). Kontaktiere uns dafür über die Kontaktseite mit den Details deiner Anfrage.",
    "privacyAdvertisingHeading": "Werbung",
    "privacyAdvertising":
      "Wir nutzen Werbedienste von Dritten, darunter Google AdSense. Diese Anbieter können Cookies und ähnliche Kennungen verwenden, um Werbung auszuliefern — auch personalisierte Werbung auf Basis deiner früheren Besuche auf dieser und anderen Websites.\n\nDu kannst personalisierte Werbung über die Google-Anzeigeneinstellungen und/oder AboutAds (Opt-out für interessenbezogene Werbung) deaktivieren. Nicht personalisierte Werbung kann weiterhin auf Basis allgemeiner Inhalte und deines Standorts angezeigt werden.",
    "privacyContactBefore": "Für Fragen oder zu exercise dein Rechte, verwenden unser ",
    "termsTitle": "Bedingungen von Verwenden",
    "termsIntro":
      "Durch den Zugriff auf diese Website (die „Website“) stimmst du diesen Bedingungen zu. Die Website stellt Informationen und Community-Werkzeuge bereit. Du verpflichtest dich, sie rechtmäßig und respektvoll zu nutzen.",
    "termsUseHeading": "Intellectual property und trademarks",
    "termsUse":
      "Die ursprünglichen Inhalte der Website (Text, Struktur, Design) gehören heartopia.guide, sofern nicht anders angegeben. Heartopia sowie Namen von Charakteren und Gegenständen, Marken und referenzierte Assets gehören ihren jeweiligen Eigentümern. Inhalte Dritter können zu Referenzzwecken erscheinen; bist du Rechteinhaber und möchtest eine Entfernung oder Änderung, kontaktiere uns.",
    "termsLiabilityHeading": "Haftungsausschluss und limitation von Haftung",
    "termsLiability":
      "Die Website wird „wie besehen“ bereitgestellt. Inhalte können unvollständig, veraltet oder vorübergehend nicht verfügbar sein. Wir garantieren weder eine kontinuierliche Verfügbarkeit noch vollständige Richtigkeit. Soweit gesetzlich zulässig, haften wir nicht für indirekte Schäden, Datenverlust, entgangene Gewinne oder andere Verluste, die aus der Nutzung der Website entstehen. Wir können die Website und diese Bedingungen jederzeit aktualisieren; die weitere Nutzung nach Änderungen gilt als Zustimmung.",
    "termsContactBefore": "Für Fragen oder Anfragen, verwenden unser ",
    "cookiesTitle": "Cookie-Richtlinie",
    "cookiesIntro":
      "Diese Cookie-Richtlinie explains wie heartopia.guide verwendet Cookies und similar technologies zu recognize visitors und verbessern der experience.",
    "cookiesWhatAreHeading": "Was Cookies sind",
    "cookiesWhatAre":
      "Cookies sind kleine Textdateien, die beim Besuch einer Website in deinem Browser gespeichert werden. Sie unterstützen Funktionen, Einstellungen und Nutzungsstatistiken.",
    "cookiesHowWeUseHeading": "Wie wir Cookies verwenden",
    "cookiesHowWeUse":
      "Wir können Cookies verwenden für: Notwendig (erforderlich) — für die Kernfunktionen der Seite (Sicherheit, Performance, wichtige Einstellungen). Einstellungen — z. B. Sprache, Design, Filter. Analyse — um zu verstehen, wie die Seite genutzt wird, und Inhalte zu verbessern. Werbung (falls zutreffend) — Partner können Cookies nutzen, um die Leistung zu messen und Werbung zu personalisieren.",
    "cookiesThirdPartyHeading": "Drittanbieter Cookies",
    "cookiesThirdParty":
      "Wir nutzen möglicherweise Dienste Dritter (z. B. Hosting, Analyse, CDNs, Werbenetzwerke). Diese Anbieter können eigene Cookies setzen. Du kannst sie über das Einwilligungs-Banner der Seite einsehen und verwalten.",
    "cookiesConsentHeading": "Einwilligung und control",
    "cookiesConsent":
      "Du kannst Cookies über das Einwilligungsbanner, deine Browsereinstellungen (Cookies blockieren oder löschen) oder den privaten/Inkognito-Modus steuern. Das Blockieren notwendiger Cookies kann Website-Funktionen beeinträchtigen.",
    "cookiesContactBefore": "Für Fragen Über uns Cookies, verwenden unser ",
    "sitemapTitle": "Sitemap",
    "sitemapIntro": "Haupt sections und Seiten von heartopia.guide.",
    "sitemapXmlLabel": "sitemap.xml",
    "sitemapXmlNote": "für Suche engines",
    "sitemapResourcesHeading": "Ressourcen",
    "sitemapSupportHeading": "Support",
    "sitemapLegalHeading": "Rechtliches",
  },
  "consent": {
    "bannerLabel": "Cookie Einwilligung",
    "message":
      "Wir verwenden Cookies für grundlegende Funktionen der Seite und, wenn du zustimmst, um die Nutzung zu messen und Werbung anzuzeigen.",
    "learnMore": "Lernen mehr Über uns Cookies",
    "acceptCta": "Accept alle",
    "rejectCta": "Nicht notwendige ablehnen",
  },
} as const;

export default dictionary;
